// Helper function to check if file is Excel
export const isExcelFileName = (fileName: string): boolean => {
  const lowerFileName = fileName.toLowerCase()
  return lowerFileName.endsWith(".xls") || lowerFileName.endsWith(".xlsx")
}

export const isPdfFileName = (fileName: string): boolean => {
  const lowerFileName = fileName.toLowerCase()
  return lowerFileName.endsWith(".pdf")
}

const EXCEL_MD_SUFFIXES = [".xlsx.md", ".xls.md", ".csv.md"]

export function stripPreprocessedSuffix(name: string): string {
  for (const suffix of EXCEL_MD_SUFFIXES) {
    if (name.endsWith(suffix)) {
      return name.slice(0, -3)
    }
  }
  return name
}

export const getFileExtension = (fileName: string): string => {
  if (!fileName) {
    return ""
  }
  const lastDotIndex = fileName.lastIndexOf(".")
  if (lastDotIndex <= 0 || lastDotIndex === fileName.length - 1) {
    return ""
  }
  return fileName.substring(lastDotIndex + 1).toLowerCase()
}
